import { OffersContainer } from '../OffersContainer';
import { List } from '../../dataProvider';

type DoubleEntryOfferProps = {
  offers: List[];
  userEntryCounts?: Record<string, number>;
  onShowEntries?: (list: List) => void;
};

export const DoubleEntryOffer = ({
  offers,
  userEntryCounts,
  onShowEntries,
}: DoubleEntryOfferProps) => {
  return (
    <OffersContainer
      offers={offers}
      userEntryCounts={userEntryCounts}
      onShowEntries={onShowEntries}
    />
  );
};
